import { Box } from '@mui/material';
import HeaderSearch from './Search';


function HeaderButtons() {
  // const { orderData, driverData } = props;
  // console.log("orderdata s  ======= ", orderData)
  // console.log("Druvers   ======= ", driverData)

  return (
    <Box sx={{ mr: 1 }}>
      <Box sx={{ mx: 0.5 }} component="span">
      </Box>
    </Box>
  );
}

export default HeaderButtons;
